const invertedMessages = {
  Sort: 'CERTS_SORT',
  Clear: 'CERTS_CLEAR',
  'Search attributes': 'CERTS_SORT_SEARCH_ATTRIBUTES',
};

export default invertedMessages;
